import { PropertyBase, PropertyBusinessType } from 'models/Properties';

export function checkGuestRequirementsFieldVisibility(
  property: Partial<Pick<PropertyBase, 'businessType'>> | undefined,
) {
  const isStandaloneProperty =
    property?.businessType === PropertyBusinessType.STANDALONE_PROPERTY;
  const isSubUnit = property?.businessType === PropertyBusinessType.SUB_UNIT;
  const isUnitType = property?.businessType === PropertyBusinessType.UNIT_TYPE;

  return isStandaloneProperty || isSubUnit || isUnitType;
}
